import React from 'react'
import PropTypes from 'prop-types'
import PrintButton from './PrintButton'
import { Link } from 'react-router-dom'

const About = props => (
  <div className='cart-side col-12 col-md-4 mt-2 mb-2 mb-md-0 mt-md-0 border-ui-3 radius bg-white px-0 py-0'>
    <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
      <h2 className='color-title txt-font-body'>{props.title}</h2>
    </div>
    <div className='cart-subtotal col-12 pb-3 mx-0'>
      {props.children}
      <PrintButton campaignHasDonation={props.campaignHasDonation} />
    </div>
    <div className='d-block d-md-none row mx-0 px-0 py-1 border-color-ui-3 border-top'>
      <div className='col-12 cart-back mx-0 px-0'>
        <Link aria-label='Ver todos os pedidos' className='d-flex' to={props.previousRoute || '/my-orders/'}>
          <i aria-hidden className='icon icon-sm icon_left pt-2 pl-2' />
          <span
            aria-hidden
            className='btn btn-sm btn-flat btn-icon txt-left pt-2 '
          >Ver todos os pedidos</span>
        </Link>
      </div>
    </div>
  </div>
)

About.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
  campaignHasDonation: PropTypes.bool,
  previousRoute: PropTypes.string
}

export default About



// WEBPACK FOOTER //
// ./src/features/About/About.js